import React from 'react';

const Section3 = () => {
  return (
    <div>
      <div className="md:mt-2">
        {/* Section 3 Header */}
        <h2 className="text-[8px] md:text-[16px] md:text-[24px] font-bold text-[#979797]">
          Section 3 : <span className="text-[#03897B]">FISCAL DATA</span>
        </h2>

        {/* Section 3 First Row */}
        <div className="grid grid-cols-4 gap-2 mt-4">
          {/* Financial year ends label */}
          <input
            type="text"
            value="Financial year ends"
            readOnly
            className="bg-[#E7EBEB] border-[#E7EBEB] w-full h-[28px] md:h-[81px] px-4 text-[6px] md:text-[24px] font-medium rounded-[5px] flex items-center whitespace-pre-line break-words text-left"
          />

          {/* Dropdown */}
          <div className="relative w-full">
            <select
              className="appearance-none bg-[#D9D9D9] border-[#D9D9D9] w-full h-[28px] md:h-[81px] px-4 pr-10 text-[6px] md:text-[24px] font-medium outline-none rounded-[5px]"
              style={{
                appearance: "none",
                WebkitAppearance: "none",
                MozAppearance: "none",
                backgroundImage: "none",
              }}
            >
              <option>March</option>
              <option>June</option>
              <option>September</option>
              <option>December</option>
            </select>
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746047265/Expand_down_15_i30bvm.png"
              alt="Dropdown Icon"
              className="pointer-events-none absolute right-4 top-1/2 transform -translate-y-1/2 h-3 w-3 md:h-11 md:w-11"
            />
          </div>
          {/* Placeholder box */}
          <input
            type="text"
            value="-"
            readOnly
            className="bg-[#E7EBEB] border-[#E7EBEB] w-full h-[28px] md:h-[81px] text-center text-[6px] md:text-[24px] font-medium rounded-[5px] flex items-center justify-center"
          />

          {/* Dropdown */}
          <div className="relative w-full">
            <select
              className="appearance-none bg-[#D9D9D9] border-[#D9D9D9] w-full h-[28px] md:h-[81px] px-4 pr-10 text-[6px] md:text-[24px] font-medium outline-none rounded-[5px]"
              style={{
                appearance: "none",
                WebkitAppearance: "none",
                MozAppearance: "none",
                backgroundImage: "none",
              }}
            >
              <option>-</option>
              <option>Option A</option>
              <option>Option B</option>
            </select>
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746047265/Expand_down_15_i30bvm.png"
              alt="Dropdown Icon"
              className="pointer-events-none absolute right-4 top-1/2 transform -translate-y-1/2 h-3 w-3 md:h-11 md:w-11"
            />
          </div>
        </div>

        {/* Section 3 Second Row */}
        <div className="grid grid-cols-4 gap-2 mt-2">
          <input
            type="text"
            value="Income Tax No:"
            readOnly
            className="bg-[#E7EBEB] border-[#E7EBEB] w-full h-[28px] md:h-[81px] px-4 text-[6px] md:text-[24px] font-medium rounded-[5px] flex items-center whitespace-pre-line break-words text-left"
          />

          <input
            type="text"
            value="987654321"
            className="bg-[#D9D9D9] border-[#D9D9D9] w-full h-[28px] md:h-[81px] px-4 text-[6px] md:text-[24px] font-medium outline-none rounded-[5px]"
          />

          <input
            type="text"
            value="VAT\nNo:"
            readOnly
            className="bg-[#E7EBEB] border-[#E7EBEB] w-full h-[28px] md:h-[81px] px-4 text-[6px] md:text-[24px] font-medium rounded-[5px] flex items-center whitespace-pre-line break-words text-left"
          />

          <input
            type="text"
            value="987654321"
            className="bg-[#D9D9D9] border-[#D9D9D9] w-full h-[28px] md:h-[81px] px-4 text-[6px] md:text-[24px] font-medium outline-none rounded-[5px]"
          />
        </div>

        {/* Section 4 Header */}
        <h2 className="text-[8px]  md:text-[24px] font-bold mt-6 md:mt-12 text-[#979797]">
          Section 4 : <span className="text-[#03897B]">PREFERRED METHOD OF CORRESPONDENCE</span>
        </h2>

        {/* Section 4 First Row */}
        <div className="grid grid-cols-4 gap-2 mt-4">
          {/* First Label as <div> */}
          <div className="bg-[#E7EBEB] border-[#E7EBEB] w-full h-[28px] md:h-[81px] px-4 text-[6px] md:text-[24px] font-medium rounded-[5px] flex items-center whitespace-pre-line break-words text-left">
            Correspondence<br />language
          </div>

          {/* First Dropdown */}
          <div className="relative w-full">
            <select
              className="appearance-none bg-[#D9D9D9] border-[#D9D9D9] w-full h-[28px] md:h-[81px] px-4 pr-10 text-[6px] md:text-[24px] font-medium outline-none rounded-[5px]"
              style={{
                appearance: "none",
                WebkitAppearance: "none",
                MozAppearance: "none",
                backgroundImage: "none",
              }}
            >
              <option>English</option>
              <option>June</option>
              <option>September</option>
              <option>December</option>
            </select>
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746047265/Expand_down_15_i30bvm.png"
              alt="Dropdown Icon"
              className="pointer-events-none absolute right-4 top-1/2 transform -translate-y-1/2 h-3 w-3 md:h-11 md:w-11"
            />
          </div>
          {/* Third Label as <div> */}
          <div className="bg-[#E7EBEB] border-[#E7EBEB] w-full h-[28px] md:h-[81px] px-4 text-[5px] md:text-[24px] font-medium rounded-[5px] flex items-center whitespace-pre-line break-words text-left">
            Preferred method<br />of communication
          </div>

          {/* Second Dropdown */}
          <div className="relative w-full">
            <select
              className="appearance-none bg-[#D9D9D9] border-[#D9D9D9] w-full h-[28px] md:h-[81px] px-4 pr-10 text-[6px] md:text-[24px] font-medium outline-none rounded-[5px]"
              style={{
                appearance: "none",
                WebkitAppearance: "none",
                MozAppearance: "none",
                backgroundImage: "none",
              }}
            >
              <option>English</option>
              <option>Call</option>
              <option>Email</option>
            </select>
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746047265/Expand_down_15_i30bvm.png"
              alt="Dropdown Icon"
              className="pointer-events-none absolute right-4 top-1/2 transform -translate-y-1/2 h-3 w-3 md:h-11 md:w-11"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section3;
